import { type FC, useId } from 'react'
import { DateInput, type DateInputProps } from './inputs/DateInput'
import { NumberInput, type NumberInputProps } from './inputs/NumberInput'
import { LayoutedPartPeriodInput, type LayoutedPartPeriodInputProps } from './inputs/PartPeriodInput'
import { TextInput, type TextInputProps } from './inputs/TextInput'
import { TitleInput, type TitleInputProps } from './inputs/TitleInput'

type InputUnion = DateInputProps | NumberInputProps | LayoutedPartPeriodInputProps | TextInputProps | TitleInputProps

export const Input: FC<InputUnion> = function Input({ ref, ...props }) {
  const key = useId()
  switch (props.type) {
    case 'date':
      return <DateInput key={key} ref={ref} {...props} />
    case 'number':
      return <NumberInput key={key} ref={ref} {...props} />
    case 'part-period':
      return <LayoutedPartPeriodInput key={key} {...props} />
    case undefined:
    case 'text':
      return <TextInput key={key} ref={ref} {...props} />
    case 'title':
      return <TitleInput key={key} ref={ref} {...props} />
  }
}
